import i18n from '@/utils/i18n';
import React from 'react';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { EmployeeNotificationsComponent } from './restaurant/employee-notifications-component';
import { ModalContainer } from '@/components/modal-container';
import { RouteProp } from '@react-navigation/native';
import { SCREEN_PADDING } from '@/styles';
import { ScrollView, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface Props {
  route: RouteProp<
    AppModalStackParams,
    APP_MODAL_ROUTES.AccountNotificationSettings
  >;
}

export const AccountNotificationsModalScreen: React.FC<Props> = ({ route }) => {
  const { bottom } = useSafeAreaInsets();

  const {
    params: { userUUID },
  } = route;
  return (
    <ModalContainer
      navigationHeaderProps={{
        title: i18n.t('notifications'),
      }}
    >
      <ScrollView
        contentContainerStyle={[
          styles.scrollView,
          { paddingBottom: Math.max(bottom, SCREEN_PADDING) },
        ]}
      >
        <EmployeeNotificationsComponent employeeUUID={userUUID} />
      </ScrollView>
    </ModalContainer>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    paddingHorizontal: SCREEN_PADDING,
  },
});
